/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import { FC, MouseEvent } from 'react';
import { Skeleton } from '@mui/material';
import { CallInfoType, CallTagType } from 'store/calls/calls.types';
import { translate } from 'localizations';
import { getGlobalStyles } from 'styles';
import { useDispatch, useSelector } from 'react-redux';
import { callsActions } from 'store/calls';
import { RootState } from 'store/store';
import { getFormattedTags } from '../../CallBody/utils';
import { callTagsLimit } from '../../constants';

import s from '../../styles.module.scss';

interface IOwnProps {
	language: string;
	tagsAndFragmentsArray: {
		tags: CallTagType[];
	};
	callInfo: CallInfoType | null;
}

const CallsTags: FC<IOwnProps> = ({ tagsAndFragmentsArray, language, callInfo }) => {
	const dispatch = useDispatch();
	const { setFragmentExpanded } = callsActions;
	const { grayTag } = getGlobalStyles();
	const { trimmedTags, reducedTags } = getFormattedTags(tagsAndFragmentsArray.tags, callTagsLimit);

	const expandedFragments = useSelector((state: RootState) => state.calls.expandedFragments);
	const callId = callInfo?.id;
	const showAllTags = callId ? expandedFragments?.[callId] || false : false;

	const tagsToDisplay = showAllTags ? tagsAndFragmentsArray.tags : trimmedTags;

	const handleShowMoreTags = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation();
		if (callId) {
			dispatch(setFragmentExpanded({ callId, isExpanded: !showAllTags }));
		}
	};

	const stopPropagation = (e: MouseEvent<HTMLElement>) => {
		e.stopPropagation();
	};

	return (
		<div className={s.container} onClick={stopPropagation}>
			{tagsAndFragmentsArray?.tags?.length > 0 ? (
				tagsToDisplay.map((tag: CallTagType, index) => (
					<div className={s.tagContainer} key={`${tag.value}-${index}`}>
						<div className={s.tag}>
							<span>{tag.name}</span>
							<span>{tag.value && `:${tag.value}`}</span>
						</div>
					</div>
				))
			) : callInfo ? (
				translate('noTags', language)
			) : (
				<div className={s.skeletonContainer}>
					<Skeleton className={s.skeleton} height={20} variant="text" />
					<Skeleton className={`${s.skeleton} ${s.skeletonWithMarginTop}`} height={20} variant="text" />
				</div>
			)}
			{reducedTags?.length > 0 && (
				<button className={grayTag} onClick={handleShowMoreTags}>
					{showAllTags
						? translate('tagHide', language)
						: `${translate('show_more', language)} (${tagsAndFragmentsArray.tags.length - callTagsLimit})`}
				</button>
			)}
		</div>
	);
};

export default CallsTags;
